import type { FrameReporter } from './types';
export type { FrameReporter } from './types';
import { timeToFrame } from './utils';

export function createFrameReporter(
  fps: number,
  onFrameChange?: (frame: number) => void,
): FrameReporter {
  let lastFrame: number | null = null;

  return {
    report(time: number) {
      const frame = timeToFrame(time, fps);
      if (frame === lastFrame) return;
      lastFrame = frame;
      onFrameChange?.(frame);
    },
  };
}
